import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './auth';

interface ViewModeContextType {
  isReadOnly: boolean;
  targetUserId: string | null;
  isPublic: boolean;
  setPublicUser: (userId: string | null) => void;
}

const ViewModeContext = createContext<ViewModeContextType | undefined>(undefined);

export const ViewModeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user } = useAuth();
  const [publicUserId, setPublicUserId] = useState<string | null>(null);

  // Check URL path immediately to avoid flashing on first render
  const pathParts = typeof window !== 'undefined' ? window.location.pathname.split('/') : [];
  const publicUserIdFromPath = pathParts[1] === 'public' ? pathParts[2] : null;

  const isPublic = !!publicUserId || !!publicUserIdFromPath;
  const isReadOnly = isPublic;
  const targetUserId = publicUserId || publicUserIdFromPath || user?.id || null;

  return (
    <ViewModeContext.Provider value={{ 
      isReadOnly, 
      targetUserId, 
      isPublic,
      setPublicUser: setPublicUserId 
    }}>
      {children}
    </ViewModeContext.Provider>
  );
};

export const useViewMode = () => {
  const context = useContext(ViewModeContext);
  if (context === undefined) {
    throw new Error('useViewMode must be used within a ViewModeProvider');
  }
  return context;
};
